import React from 'react';
import { Tooltip } from '@material-ui/core';

const COLORS = {
	GREEN   : '#25d366',
	YELLOW  : '#f5b915',
	RED     : '#e74c3c',
	UNKNOWN : '#8696a0',
};

const LABELS = {
	GREEN   : 'Boa',
	YELLOW  : 'Média',
	RED     : 'Ruim',
	UNKNOWN : 'Desconhecida',
};

const formatDate = ( unixSeconds ) => {
	if ( !unixSeconds ) {
		return null;
	}
	return new Date( unixSeconds * 1000 ).toLocaleString( 'pt-BR', {
		day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
	} );
};

const QualityBadge = ( { status, date } ) => {
	const key = status && COLORS[ status ] ? status : 'UNKNOWN';
	const formattedDate = formatDate( date );

	const badge = (
		<span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#54656f' }}>
			<span style={{
				width        : '8px',
				height       : '8px',
				borderRadius : '50%',
				background   : COLORS[ key ],
				display      : 'inline-block',
			}} />
			{LABELS[ key ]}
		</span>
	);

	if ( !formattedDate ) {
		return badge;
	}

	return (
		<Tooltip title={`Atualizado pela Meta em ${formattedDate}`} arrow placement="top">
			{badge}
		</Tooltip>
	);
};

export default QualityBadge;
